import './social-feed.component.pug'
import './social-feed.component.scss'

import lozad from 'lozad'
import { Swiper, Mousewheel, Autoplay } from 'swiper'

Swiper.use([Mousewheel, Autoplay])

document.querySelectorAll('.social-feed').forEach((root) => {
  const swiper = new Swiper(root.querySelector('.swiper-container'), {
    init: false,
    spaceBetween: 10,
    slidesPerView: 'auto',
    autoplay: {
      delay: 3000,
      stopOnLastSlide: true
    },
    freeMode: true,
    edgeSwipeDetection: 'prevent',
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: false
    },
    breakpoints: {
      768: {
        spaceBetween: 20
      }
    }
  })
  swiper.autoplay.stop()
  lozad(root, {
    load() {
      swiper.init()
      swiper.autoplay.start()
    }
  }).observe()
})
